import { useState, useEffect } from 'react';

export const useRuleFilters = (rules) => {
  const [filteredRules, setFilteredRules] = useState([]);
  const [selectedRuleType, setSelectedRuleType] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    applyFilters();
  }, [rules, selectedRuleType, searchTerm]);

  const applyFilters = () => {
    let filtered = [...rules];

    // Filter by rule type
    if (selectedRuleType) {
      filtered = filtered.filter(rule => rule.ruleType === selectedRuleType);
    }

    // Filter by search term (name)
    if (searchTerm) {
      const lowerSearch = searchTerm.toLowerCase();
      filtered = filtered.filter(rule => 
        rule.name.toLowerCase().includes(lowerSearch)
      );
    }

    // Always sort by execution order to maintain correct sequence
    filtered.sort((a, b) => a.executionOrder - b.executionOrder);

    setFilteredRules(filtered);
  };

  return {
    filteredRules,
    selectedRuleType,
    setSelectedRuleType,
    searchTerm,
    setSearchTerm,
  };
};
